export default __webpack_public_path__ + "static/media/DocuWareLogo32px.e9c2ef4a.svg";